import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MuiPaper from 'material-ui/Paper';
import MuiFlatButton from 'material-ui/FlatButton';
import styles from './styles';
import './index.css';
import timer from './img/timer.gif';

export default class ManualActivationStepTwo extends Component {
  static propTypes = {
    moveForward: PropTypes.func,
    moveBackwards: PropTypes.func,
  }

  render() {
    return (
      <div className="activate-step-two">
        <MuiPaper style={ styles.paperStyle } zDepth={ 3 } className="activate-step-paper">
          <div className="activate-step-content">
            <p className="activate-step-timer">
              <img className="step-two-timer" src={ timer } alt="15 second countdown timer" />
              <span><span className="semibold">Step 2.</span> Press and hold the button for <span className="semibold">15 seconds</span>.</span>
            </p>
          </div>

          <div className="activate-step-buttons clearfix">
            <MuiFlatButton
              className="activate-step-prev"
              label="Previous"
              labelStyle={ styles.prevLabelStyle }
              hoverColor="transparent"
              rippleColor="transparent"
              style={ styles.flatButtonStyle }
              onClick={ this.props.moveBackwards }
            />
            <MuiFlatButton
              className="activate-step-next"
              label="Next"
              labelStyle={ styles.nextLabelStyle }
              hoverColor="transparent"
              primary={ true }
              rippleColor="transparent"
              style={ styles.flatButtonStyle }
              onClick={ this.props.moveForward }
            />
          </div>
        </MuiPaper>
      </div>
    );
  }
}
